import defaultTemplate from "./default.js";
import condensedTemplate from "./condensed.js";
import style5ATemplate from "./style5A.js";
import technicolorTemplate from "./technicolor.js";
import starterTemplate from "./starter.js";

/**
 * Registry of all CCSL export templates.
 * Keyed by template ID string (matches the <select> option values in CcslExport.svelte).
 * 
 * Each template implements the interface:
 *  - id: string
 *  - getDocumentConfig(): { orientation, useSections, hasPageHeader }
 *  - getHeaders(): TableRow[]
 *  - buildDialogueRowWithSpotting(event, index, spottingEvents, spottingEventGroup, project): TableRow[]
 *  - buildDialogueRowWithoutSpotting(event, index, project): TableRow[]
 */
const ccslTemplates = {
    default: defaultTemplate,
    condensed: condensedTemplate,
    style5A: style5ATemplate,
    technicolor: technicolorTemplate,
    starter: starterTemplate,
};

export default ccslTemplates;
